import React from "react";
import {
  Stack,
  Grid,
  Dialog,
  Divider,
  IconButton,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import { navigate } from "gatsby-link";
import CancelIcon from "@mui/icons-material/Cancel";

import SignUpForm from "./SignUpForm";
import SignUpOptions from "./SignUpOptions";

export default function SignUpModal({ firebase, user, uid, open = true, handleClose = () => { }, onSignUpSuccess = () => { navigate("/checkout") }, onSignupFailure = () => {} }) {

  return (
    <Dialog open={open} onClose={handleClose} scroll="paper" maxWidth="1200px">
      <DialogTitle id="scroll-dialog-title">
        <Stack width="100%" alignItems="flex-end">
          <IconButton onClick={handleClose}>
            <CancelIcon fontSize="medium" color="secondary.main" />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={{ xs: 1, md: 0 }}>
          <Grid item xs={12} md={12}>
            <SignUpForm firebase={firebase} user={user} uid={uid} onSignUpSuccess={onSignUpSuccess} onSignupFailure={onSignupFailure} />
          </Grid>
          {false &&
            <Grid item xs={12} md={2}>
              <Stack height="100%" alignItems="center" justifyContent="center">
                <Divider orientation="vertical" />
              </Stack>
            </Grid>
          }
          {false &&
            <Grid item xs={12} md={5}>
              <SignUpOptions />
            </Grid>
          }
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
